<!--Login template-->
<template>
    <div class="login">
      <div class="useremail">
        <div class="center">
          <svg width="117" height="118" viewBox="0 0 117 118" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(2.7 3)" fill="none" fill-rule="evenodd">
              <circle fill="#FFEAEA" cx="56" cy="56" r="47.6"/>
              <circle stroke="#FFEAEA" stroke-width="4.2" cx="56" cy="56" r="56"/>
              <g stroke="#00A1D4" stroke-linejoin="round" stroke-width="2.1">
                <path d="M42.854 44.976c-1.86 5.111-5.945 8.318-9.124 7.16-3.18-1.157-4.247-6.238-2.387-11.35 1.86-5.11 5.945-8.317 9.124-7.16 3.18 1.157 4.247 6.239 2.387 11.35zM59.986 35.983c-1.508 4.71-5.105 7.766-8.032 6.83-2.93-.932-4.081-5.506-2.574-10.212 1.508-4.709 5.103-7.766 8.032-6.832 2.93.934 4.08 5.51 2.574 10.214zM72.118 55.627c-1.86 5.111-.793 10.193 2.387 11.35s7.264-2.049 9.124-7.16c1.86-5.111.792-10.193-2.387-11.35-3.18-1.157-7.264 2.049-9.124 7.16zM64.775 37.726c-1.872 4.577-1.081 9.23 1.762 10.395 2.844 1.17 6.666-1.594 8.536-6.168 1.872-4.577 1.083-9.23-1.761-10.397-2.845-1.167-6.667 1.599-8.537 6.17zM62.353 61.373c.659-4.26.04-9.889-4.673-11.604-4.712-1.715-8.804 2.198-11.038 5.886-2.408 3.98-10.46 4.298-12.776 10.66-4.46 12.253 26.962 23.69 31.421 11.437 2.316-6.363-3.648-11.782-2.934-16.38z"/>
              </g>
            </g>
          </svg>
          <h1 class="mb4 mt1">LemmikkiHelppi</h1>
        </div>
        <form @submit.prevent>
          <div class="form-group">
            <label class="label">Kirjaudu sähköpostiosoitteellasi</label>
            <input type="text" placeholder="Anna sähköpostiosoitteesi" class="form-control" v-model="useremail" >
          </div>
          <button type="submit" class="button button-primary" @click="submitEmail(useremail)">Kirjaudu</button>
          <div v-if="message">
            <div class="message">{{message}}</div>
          </div>
          <div v-if="errorMessage">
            <div class="message message-error">{{errorMessage}}</div>
          </div>
          <div v-if="forceLogoutMessage">
            <div class="message message-error">{{forceLogoutMessage}}</div>
          </div>
          <div v-if="browser.name !== 'chrome'">
            <div class="message message-error">Vaihda selain Google Chromeen</div>
          </div>
        </form>
      </div>
    </div>
</template>

<script>

import Api from '@/api'
import { mapGetters } from 'vuex';
import { detect } from 'detect-browser';

export default {
  name: 'Login',
  data() {
    return {
      errorMessage: '',
      message: '',
      useremail: null,
      browser: detect() || {},
    }
  },
  computed: {
    ...mapGetters({
      forceLogoutMessage: 'forceLogoutMessage',
    })
  },
  mounted: function() {
    if (this.$route.query.token) {
      const emailtoken = this.$route.query.token;
      this.login(emailtoken);
    } else if (localStorage.jwtToken) {
      this.$router.push('/');
    }
  },
  methods: {
    submitEmail(useremail) {
      if(useremail == null) {
        this.errorMessage = 'Anna sähköpostiosoite';
      } else {
        this.sendEmail(useremail);
      }
    },
    sendEmail(useremail) {
      Api.sendLoginEmail(useremail)
        .then(() => {
        this.message = `Kirjautumislinkki on lähetetty sähköpostiisi \n ${useremail}`;
        this.errorMessage = '';
        }).catch((error) => {
          console.log(error);
          if (error == 'Error: Network Error') {
            this.errorMessage = 'Palvelimeen ei saada yhteyttä, yritä hetken kuluttua uudestaan';
            this.message = '';
          } else {
            this.errorMessage = 'Sähköpostiosoitteella ei ole oikeutta kirjautua';
            this.message = '';
          }
      });
      this.$store.commit('RESET_FORCE_LOGOUT_MESSAGE');
    },
    login(token) {
      Api.login(token)
      .then(response => {
        const jwtToken = response.data.token;
        localStorage.jwtToken = jwtToken;
        this.$store.commit('LOGGED_IN');
        this.$router.push('/');
      }).catch((error) => {
        //TODO: show token is expired thingy
        this.errorMessage = 'Linkki on jo käytetty tai käyttäjätunnus on poistettu käytöstä';
      })
      }
  },
}
</script>

<style scoped>
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-image: linear-gradient(-180deg, #00A1D4 26%, #10416D 100%);
    color: #fff;
  }

  .message {
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 1.125rem;
    background-color: #74CBE8;
    color: #fff;
    font-weight: bold;
    font-size: var(--h5);
  }

  .message-error {
    background-color: #fff;
    color: #F00020;
  }

  .useremail {
    padding: 1rem;
    max-width: 380px;
  }

  .label {
    display: block;
    margin-bottom: .75rem;
  }

  input,
  .button {
    display: block;
    width: 100%;
    padding: 1rem;
    border: 0;
    border-radius: 1.25rem 1.25rem 0;
    font-size: .875rem;
  }

  input {
    margin-bottom: .75rem;
  }

  .button {
    cursor: pointer;
    background-color: #FFEAEA;
    color: #003665;
  }
</style>
